// extracted by mini-css-extract-plugin
export default {"finishSetup":"_16ouxuu","header":"_1qtpk9d","appCard":"_3ggmx9","column":"_1om6rve","addToSite":"_12hds4f","manageAppsLink":"_17yfhat"};